import { mapAppLocale } from '@protector/utils/app-locale-map';
import localeRU from 'antd/lib/locale/ru_RU';
import type { Locale } from 'antdV3/lib/locale-provider';
import localeDE from 'antdV3/lib/locale/de_DE';
import localeEL from 'antdV3/lib/locale/el_GR';
import localeEN from 'antdV3/lib/locale/en_US';
import localeES from 'antdV3/lib/locale/es_ES';
import localeFR from 'antdV3/lib/locale/fr_FR';
import localeHU from 'antdV3/lib/locale/hu_HU';
import localeIT from 'antdV3/lib/locale/it_IT';
import localePL from 'antdV3/lib/locale/pl_PL';
import localeBR from 'antdV3/lib/locale/pt_BR';
import localePT from 'antdV3/lib/locale/pt_PT';
import { getCurrentLanguage } from 'core/utils/functions';
import { cloneDeep } from 'lodash';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const ANTD_LOCALE_BY_CANONICAL: Record<string, Locale> = {
  en: localeEN,
  'pt-br': localeBR,
  'pt-pt': localePT,
  es: localeES,
  de: localeDE,
  el: localeEL,
  fr: localeFR,
  hu: localeHU,
  it: localeIT,
  pl: localePL,
  ru: localeRU as unknown as Locale
};

const getLocaleByLanguage = (language: string): Locale => ANTD_LOCALE_BY_CANONICAL[mapAppLocale(language)] ?? localeEN;

const useAntdLocale = () => {
  const [t] = useTranslation();

  const [locale, setLocale] = useState<Locale>(() => getLocaleByLanguage(getCurrentLanguage()));

  useEffect(() => {
    const currentLanguage = getCurrentLanguage();

    const originalLocaleByLanguage = getLocaleByLanguage(currentLanguage);

    const localeByLanguage = cloneDeep(originalLocaleByLanguage);

    if (
      typeof localeByLanguage.DatePicker === 'object' &&
      'lang' in localeByLanguage.DatePicker &&
      'timeSelect' in (localeByLanguage.DatePicker.lang as Record<'timeSelect', string>)
    ) {
      (localeByLanguage.DatePicker.lang as Record<'timeSelect', string>).timeSelect = t('antd.date_picker.lang.time_select');
    }

    setLocale(localeByLanguage);
  }, [t]);

  return locale;
};

export default useAntdLocale;
